var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlertError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.34636 7.00001L0.366306 3.20948C-0.122103 2.74433 -0.122103 1.99016 0.366306 1.52463L1.25085 0.682207C1.73926 0.217056 2.53114 0.217056 3.01994 0.682207L7 4.47274L10.9801 0.682207C11.4685 0.217056 12.2603 0.217056 12.7491 0.682207L13.6337 1.52463C14.1221 1.98978 14.1221 2.74395 13.6337 3.20948L9.65364 7.00001L13.6337 10.7905C14.1221 11.2557 14.1221 12.0099 13.6337 12.4754L12.7491 13.3178C12.2607 13.783 11.4685 13.783 10.9801 13.3178L7 9.52728L3.01994 13.3178C2.53153 13.783 1.73926 13.783 1.25085 13.3178L0.366306 12.4754C-0.122103 12.0102 -0.122103 11.2561 0.366306 10.7905L4.34636 7.00001Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertError);
export default __webpack_public_path__ + "static/media/AlertError.dda49a0d818ea674c0d1422e6548399d.svg";
export { ForwardRef as ReactComponent };